var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26696(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26696",
    "data-name": "Group 26696",
    transform: "translate(-792 -788)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(792 788)",
    fill: "#8430c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23254",
    "data-name": "Path 23254",
    d: "M572.549,81.272l2.578-7.366a7.033,7.033,0,0,1,6.639-4.711h13.278a7.035,7.035,0,0,1,6.639,4.711l2.579,7.366a4.7,4.7,0,0,1,2.9,4.338v14.07a2.342,2.342,0,0,1-2.345,2.345h-2.345a2.342,2.342,0,0,1-2.345-2.345V96.162H576.681v3.517a2.343,2.343,0,0,1-2.345,2.345h-2.345a2.343,2.343,0,0,1-2.345-2.345V85.61a4.693,4.693,0,0,1,2.9-4.338m4.132,4.338a2.345,2.345,0,1,0,2.345,2.345,2.343,2.343,0,0,0-2.345-2.345m.96-4.69h21.53l-1.913-5.467a2.345,2.345,0,0,0-2.213-1.568H581.767a2.345,2.345,0,0,0-2.213,1.568Zm22.49,9.38a2.345,2.345,0,1,0-2.345-2.345A2.342,2.342,0,0,0,600.13,90.3",
    transform: "translate(239.354 738.805)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26696);
export default __webpack_public_path__ + "static/media/Group 26696.6f06123ab39981e3650c93a2399257a7.svg";
export { ForwardRef as ReactComponent };